import React from 'react'
import { FormattedMessage } from 'react-intl'
import Link from 'redux-first-router-link'
import Card from 'components/Card'

import SimpleActivity from './SimpleActivity'
import ActivityObject from './ActivityObject'
import ReactionActivity from './ReactionActivity'
import AbbreviatedPersonList from './AbbreviatedPersonList'
import styles from './Activity.css'
import RelativeTime from 'components/RelativeTime'

const extractActors = (activities, users) => {
  return activities.map(a => users[a.actor.id])
}

const AggregatedActivityInfo = ({ group, entities, you }) => {
  if (/.*join|group/.test(group.verb)) {
    let a = group.activities[0]
    const actor = entities[a.actor.type][a.actor.id]
    const object = entities[a.object.type][a.object.id]
    const target = a.target ? entities[a.target.type][a.target.id] : undefined
    const origin = a.origin && entities[a.origin.type][a.origin.id]
    let groupId = a.group || (origin && origin.type === 'group' && origin.id)
    let g = groupId && entities['group'][groupId]
    if (object) {
      return (
        <ActivityObject
          key={a.id}
          you={you}
          verb={a.verb}
          object={object}
          actor={actor}
          target={target}
          group={g}
          showActor={true}
          users={entities.user}
          reactions={entities.reaction}
        />
      )
    } else {
      return null
    }
  } else {
    if (/.*react/.test(group.verb)) {
      let a = group.activities[0]
      let post = entities[a.target.type][a.target.id]
      let author = entities.user[post.author]
      return <ReactionActivity post={post} author={author} />
    } else {
      return group.activities.map(a => {
        const actor = entities[a.actor.type][a.actor.id]
        const object = entities[a.object.type][a.object.id]
        const target = a.target
          ? entities[a.target.type][a.target.id]
          : undefined
        const origin = a.origin && entities[a.origin.type][a.origin.id]
        let groupId =
          a.group || (origin && origin.type === 'group' && origin.id)
        let g = groupId && entities['group'][groupId]
        if (!object) return <span key={a.id} />
        return (
          <ActivityObject
            key={a.id}
            you={you}
            verb={a.verb}
            object={object}
            actor={actor}
            target={target}
            group={g}
            showActor={true}
            users={entities.user}
            reactions={entities.reaction}
            aggregated_mode={true}
          />
        )
      })
    }
  }
}

const AggregatedActivity = ({ you, group, entities, notificationMode }) => {
  if (group.activity_count === 1) {
    // render the simple version, since there is only one
    const a = group.activities[0]
    const actor = entities[a.actor.type][a.actor.id]
    const object = entities[a.object.type][a.object.id]
    const target = a.target && entities[a.target.type][a.target.id]
    const origin = a.origin && entities[a.origin.type][a.origin.id]
    let grp =
      (a.object && a.object.type === 'group' && a.object.id) ||
      (a.origin && a.origin.type === 'group' && a.origin.id)
    const g = grp && entities['group'][grp]

    if (grp && !g) {
      return null // group has mysteriously disappeared (e.g. someone deleted it)
    } else {
      return (
        <SimpleActivity
          you={you}
          value={{
            ...a,
            actor,
            object,
            target,
            group: g
          }}
          users={entities.user}
          groups={entities.group}
          reactions={entities.reaction}
          notificationMode={notificationMode}
        />
      )
    }
  } else {
    // render the aggregated version
    const { actors, activities } = group
    const { user: users, post: posts } = entities
    const groupId = activities[0].group
    const g = groupId && entities['group'][groupId]
    return (
      <Card className={styles.activity}>
        <div className={styles.description}>
          <AbbreviatedPersonList
            showCount={2}
            people={Object.getOwnPropertyNames(actors).map(id => users[id])}
          />&nbsp;
          <span className={styles.aggregated_verb}>
            <FormattedMessage
              id={`activity.verbs.${group.verb}`}
              values={group}
            />
            {g ? (
              <span className={styles.published}>
                <FormattedMessage id={`activity.in_group`} />
                <Link
                  to={{
                    type: 'groups/group/activity',
                    payload: {
                      group: g._id
                    }
                  }}
                >
                  {g.name}
                </Link>
              </span>
            ) : null}
            <RelativeTime unit="day" value={group.updated_at} />
          </span>
        </div>
        <div className={styles.aggregated_activities}>
          <AggregatedActivityInfo you={you} group={group} entities={entities} />
        </div>
      </Card>
    )
  }
}

export default AggregatedActivity
